import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {fetchMenusIfNeeded} from '../../actions'
import TeamImage from './TeamImage.png'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'

export class TeamView extends React.Component {

  drawBackgroundImage () {
    return {
      backgroundImage: `url('${TeamImage}')`
    }
  }

  componentDidMount () {
    const {dispatch} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
  }

  componentWillReceiveProps (nextProps) {
    const {selectedScope, dispatch} = nextProps
    if (selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(selectedScope))
    }
  }

  render () {
    const {menus, dispatch} = this.props
    const bottom_menus = menus.bottom || []
    const top_menus = menus.top || []
    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='about-view' className='row team-view'>
          <div className='col-md-12 text-left'>
            <p className='left-tag'>equipa</p>
          </div>
          <div className='row main-block'>
            <div className='col-sm-4 col-md-3 side-block no-pad'>
              <div className='thumb' style={this.drawBackgroundImage()}></div>
              <div className='desc'>
                <p className='title'>VEM TRABALHAR<br/>CONNOSCO!</p>
                <p>Estamos a preparar a 9ª edição da Festa do Cinema Italiano e a construir a equipa.
                  <br/>Precisamos de pessoas para a área de produção com experiência em organização
                    de eventos, e um técnico de pós-produção áudio-vídeo com alguma experiência
                    na área.
                  <br/>Se conheceres alguém que se enquadre, manda-nos, até 31 de Janeiro, o CV para:
                  <br/>info@festadocinemaitaliano.com
                  <br/>Ti aspettiamo!
                </p>
              </div>
            </div>
            <div className='col-sm-8 col-md-offset-1 col-md-8'>
              <div className='txt-block'>
                <strong>9ª EDIÇÃO - LISBOA - 30 de março a 7 de abril de 2016</strong>
              </div>
              <div className='txt-block'>
                <strong>DIREÇÃO ARTÍSTICA</strong>
                <p>Stefano Savio</p>
              </div>
              <div className='txt-block'>
                <strong>PROGRAMAÇÃO</strong>
                <p>Stefano Savio | Adriano Smaldone | Anette Dujisin</p>
              </div>
              <div className='txt-block'>
                <strong>DIREÇÃO DE COMUNICAÇÃO</strong>
                <p>Maria João Teixeira</p>
              </div>
              <div className='txt-block'>
                <strong>ASSESSORIA DE IMPRENSA</strong>
                <p>Helena César - Speak</p>
              </div>
              <div className='txt-block'>
                <strong>DIREÇÃO TÉCNICA</strong>
                <p>Adriano Smaldone</p>
              </div>
              <div className='txt-block'>
                <strong>EDIÇÃO DE CONTEÚDOS</strong>
                <p>Anette Dujisin</p>
              </div>
              <div className='txt-block'>
                <strong>ATIVIDADES PARALELAS</strong>
                <p>Clelia Bettini</p>
              </div>
              <div className='txt-block'>
                <strong>ATIVIDADES PEDAGÓGICAS</strong>
                <p>Elisabetta Maino | Francesca Casolino</p>
              </div>
              <div className='txt-block'>
                <strong>ATIVIDADES PARALELAS</strong>
                <p>Clelia Bettini</p>
              </div>
              <div className='txt-block'>
                <strong>ATIVIDADES PARALELAS</strong>
                <p>Clelia Bettini</p>
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

TeamView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  selectedScope: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedScope
  }
}

export default connect(mapStateToProps)(TeamView)



// WEBPACK FOOTER //
// ./src/views/AboutView/TeamView.js